import axios from "axios";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Multiselect from "multiselect-react-dropdown";

function LoadingModal({ uploadProgress }) {
  return (
    <div
      className="loading-modal"
      style={{
        display: "flex",
        background: "rgba(0, 0, 0, 0.7)",
        backdropFilter: "blur(5px)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1050,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: 16,
      }}
    >
      <div
        className="spinner-border"
        role="status"
        style={{ color: "#fff", width: 48, height: 48 }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <div style={{ color: "#fff", marginTop: 16, width: "280px" }}>
        {/* Uploading: {uploadProgress}% */}
        <div style={{ fontSize: 14, marginBottom: 6 }}>
          Uploading: {uploadProgress}%
        </div>
        <div
          style={{
            height: 6,
            background: "rgba(255,255,255,0.25)",
            borderRadius: 999,
          }}
        >
          <div
            style={{
              width: `${uploadProgress}%`,
              height: "100%",
              background: "#25d366",
              borderRadius: 999,
            }}
          />
        </div>
      </div>
    </div>
  );
}

function CsvHeadersCustomerModal({
  csvHeaders,
  onClose,
  file,
  fetchContactData,
}) {
  const [customsData, setCustomsData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const selectedKeys = [
    "name",
    "email",
    "mobile",
    "whatsappMobile",
    "personalisedattachment",
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const customFieldResponse = await axios.get("/api/contact/customfield");
        const contactResponse = await axios.get("/api/contact/getallcontact");

        const extractedTitles = customFieldResponse.data.map(
          (custom) => custom.title
        );

        const firstContact = contactResponse.data[0];
        const extractedKeys = Object.keys(firstContact).filter((key) =>
          selectedKeys.includes(key)
        );

        setCustomsData(extractedTitles);
        setContactData(extractedKeys);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [selectedOptions, setSelectedOptions] = useState({});

  const handleOptionChange = (header, selectedOption) => {
    setSelectedOptions({
      ...selectedOptions,
      [header]: selectedOption,
    });
  };

  const readFileAsync = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsText(file);
    });
  };

  // const handleMapping = async () => {
  //   try {
  //     setLoading(true);

  //     const csvFile = file;
  //     const contents = await readFileAsync(csvFile);
  //     const csvData = contents.split("\n");

  //     const totalRows = csvData.length - 1; // excluding header row
  //     let batchSize = 100; // Start with a base batch size
  //     if (totalRows > 10000) {
  //       batchSize = 1000;
  //     } else if (totalRows > 5000) {
  //       batchSize = 500;
  //     } else if (totalRows > 2000) {
  //       batchSize = 200;
  //     }

  //     let currentRow = 0;
  //     const mappedData = [];

  //     for (let i = 1; i < csvData.length; i++) {
  //       const row = csvData[i].split(",");
  //       const mappedContact = {};

  //       for (const header in selectedOptions) {
  //         const columnIndex = csvHeaders.indexOf(header);
  //         const mapping = selectedOptions[header];

  //         if (columnIndex !== -1 && row[columnIndex] !== undefined) {
  //           mappedContact[mapping] = row[columnIndex].trim();
  //         }
  //       }
  //       mappedData.push(mappedContact);

  //       // Check if batch size is reached or if it's the last row
  //       if (mappedData.length === batchSize || i === csvData.length - 1) {
  //         // Send the current batch to the server
  //         await axios.post("/api/contact/addcustomer", mappedData);

  //         // Update the upload progress
  //         currentRow += mappedData.length;
  //         const progress = Math.round((currentRow / totalRows) * 100);
  //         setUploadProgress(progress);

  //         // Clear the current batch
  //         mappedData.length = 0;
  //       }
  //     }

  //     onClose();
  //     Swal.fire({
  //       icon: "success",
  //       title: "Success!",
  //       text: "Contacts added successfully from CSV file",
  //     });
  //     fetchContactData();
  //   } catch (error) {
  //     console.error("Error mapping CSV data:", error);
  //   } finally {
  //     setLoading(false);
  //     setUploadProgress(0);
  //   }
  // };

  const handleMapping = async () => {
    try {
      setLoading(true);

      const csvFile = file;
      const contents = await readFileAsync(csvFile);
      const csvData = contents.split("\n");

      const totalRows = csvData.length - 1;
      let batchSize = 100;
      if (totalRows > 10000) batchSize = 1000;
      else if (totalRows > 5000) batchSize = 500;
      else if (totalRows > 2000) batchSize = 200;

      let currentRow = 0;
      let mappedData = [];

      for (let i = 1; i < csvData.length; i++) {
        const row = csvData[i].split(",");
        const mappedContact = {};

        for (const header in selectedOptions) {
          const columnIndex = csvHeaders.indexOf(header);
          const mapping = selectedOptions[header];

          if (columnIndex !== -1 && row[columnIndex] !== undefined) {
            mappedContact[mapping] = row[columnIndex].trim();
          }
        }

        // ✅ Add tag field
        mappedContact.tag = selectedTags;

        // ✅ Skip completely empty rows
        if (
          !mappedContact.name &&
          !mappedContact.email &&
          !mappedContact.mobile &&
          !mappedContact.whatsappMobile
        ) {
          continue;
        }

        mappedData.push(mappedContact);

        // ✅ Send in batches
        if (mappedData.length === batchSize) {
          await axios.post("/api/contact/addcustomer", mappedData);

          currentRow += mappedData.length;
          const progress = Math.round((currentRow / totalRows) * 100);
          setUploadProgress(progress);

          mappedData = []; // reset batch
        }
      }

      // ✅ Flush remaining data after loop
      if (mappedData.length > 0) {
        await axios.post("/api/contact/addcustomer", mappedData);
      }

      onClose();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Contacts added successfully from CSV file",
      });
      fetchContactData();
    } catch (error) {
      console.error("Error mapping CSV data:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong while uploading data",
      });
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  };

  const [showAlert, setShowAlert] = useState(true);

  const hideAlert = () => {
    setShowAlert(false);
  };

  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, []);

  const [selectedTags, setSelectedTags] = useState([]);

  const handleChangeTags = (selectedTags) => {
    setSelectedTags(selectedTags);
  };

  const [options, setOptions] = useState([]);

  useEffect(() => {
    const getTagsData = async () => {
      try {
        const response = await axios.get("/api/contact/tags/gettags");
        const responseData = response.data;

        const getTagsName = responseData.map((tag) => tag.title);

        setOptions(getTagsName);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getTagsData();
  }, []);

  return (
    <>
      {loading ? (
        <LoadingModal uploadProgress={uploadProgress} />
      ) : (
        <div
          className="modal"
          style={{
            display: "block",
            background: "rgba(0, 0, 0, 0.7)",
            backdropFilter: " blur(5px)",
          }}
        >
          <div
            className="modal-dialog modal-dialog-scrollable"
            style={{
              maxWidth: "900px", // 👈 Increase width
              width: "70%", // 👈 Responsive width
            }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: 16,
                boxShadow: "0 20px 60px rgba(2,24,52,0.2)",
                overflow: "hidden",
              }}
            >
              <div
                className="modal-header"
                style={{
                  background: "#f8fafc",
                  borderBottom: "1px solid #eef2f7",
                  padding: "14px 16px",
                }}
              >
                {/* <h5 className="modal-title">CSV File</h5> */}

                <div>
                  <h5
                    className="modal-title"
                    style={{ margin: 0, fontWeight: 700 }}
                  >
                    Map CSV Columns
                  </h5>
                  <div style={{ fontSize: 12, color: "#6b7a90" }}>
                    Match your CSV headers to contact fields
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close close"
                  onClick={onClose}
                ></button>
              </div>
              <div>
                {showAlert && (
                  <div
                    className="alert alert-warning alert-dismissible fade show"
                    role="alert"
                  >
                    <div style={{ textAlign: "left", marginLeft: "20px" }}>
                      <strong>Note:</strong>
                      <ul>
                        <li>
                          <strong>1.</strong> Add at least one contact before
                          importing the data from the CSV file.
                        </li>
                        <li>
                          <strong>2.</strong> Only, 4000 rows of data can be
                          imported through the CSV file.
                        </li>
                      </ul>
                    </div>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={hideAlert}
                    ></button>
                  </div>
                )}
              </div>
              <div className="modal-body" style={{ paddingTop: 12 }}>
                <ul style={{ margin: 0, padding: 0 }}>
                  {csvHeaders.map((header, index) => (
                    <li
                      key={index}
                      // style={{
                      //   display: "flex",
                      //   alignItems: "center",
                      //   lineHeight: "60px",
                      //   justifyContent: "space-between",
                      //   width: "100%",
                      //   gap: "10px",
                      // }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        minHeight: 56,
                        justifyContent: "space-between",
                        width: "100%",
                        gap: 12,
                        padding: "8px 10px",
                        border: "1px solid #eef2f7",
                        borderRadius: 10,
                        marginBottom: 8,
                        background: "#fff",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#0f172a",
                          flex: 1,
                        }}
                      >
                        {header}
                      </div>
                      <select
                        className="btn btn-light"
                        style={{
                          maxWidth: "250px", //  Limit width
                          minWidth: "200px", //  Prevent too small
                          textAlign: "left",
                        }}
                        value={selectedOptions[header] || ""}
                        onChange={(e) =>
                          handleOptionChange(header, e.target.value)
                        }
                      >
                        <option value="">Select Option</option>
                        {contactData.map((contact, contactIndex) => (
                          <option key={contactIndex} value={contact}>
                            {contact}
                          </option>
                        ))}
                        {customsData.map((custom, customIndex) => (
                          <option key={customIndex} value={custom}>
                            {custom}
                          </option>
                        ))}
                      </select>
                    </li>
                  ))}
                  <li
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   lineHeight: "60px",
                    //   justifyContent: "space-between",
                    //   width: "100%",
                    //   gap: "10px",
                    // }}

                    style={{
                      display: "flex",
                      alignItems: "center",
                      minHeight: 56,
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 12,
                      padding: "8px 10px",
                      border: "1px solid #eef2f7",
                      borderRadius: 10,
                      marginBottom: 8,
                      background: "#fff",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: "#0f172a",
                        flex: 1,
                      }}
                    >
                      Tags
                    </div>
                    <div
                      style={{ maxWidth: 260, minWidth: 260, width: "100%" }}
                    >
                      <Multiselect
                        // className="btn btn-light"
                        className="multiselect-container-customer-model"
                        isObject={false}
                        onSelect={(selectedList) =>
                          handleChangeTags(selectedList)
                        }
                        onRemove={(selectedList) =>
                          handleChangeTags(selectedList)
                        }
                        options={options}
                        selectedValues={selectedTags} // Pass selected tags to the Multiselect component
                        placeholder="Select tags"
                        showCheckbox
                        style={{
                          multiselectContainer: { padding: 0, maxWidth: 260 },
                          searchBox: {
                            border: "1px solid #ced4da",
                            borderRadius: 6,
                            minHeight: 38,
                            padding: "6px 10px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          },
                          chips: { background: "#1976d2" },
                          optionContainer: {
                            width: 260,
                            maxWidth: 260,
                            overflowY: "auto",
                            maxHeight: 240,
                          },
                          option: {
                            padding: "6px 10px",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            maxWidth: 228,
                          },
                        }}
                      />
                    </div>
                  </li>
                </ul>
              </div>
              <div
                className="modal-footer"
                style={{ borderTop: "1px solid #eef2f7" }}
              >
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary w-50"
                  onClick={handleMapping}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CsvHeadersCustomerModal;
